import { render, staticRenderFns } from "./BanquetType.vue?vue&type=template&id=77ed3233&scoped=true&"
import script from "./BanquetType.vue?vue&type=script&lang=js&"
export * from "./BanquetType.vue?vue&type=script&lang=js&"
import style0 from "./BanquetType.vue?vue&type=style&index=0&id=77ed3233&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ed3233",
  null
  
)

export default component.exports